import { render, staticRenderFns } from "./AdminAddCompany.vue?vue&type=template&id=147921dc&scoped=true&"
import script from "./AdminAddCompany.vue?vue&type=script&lang=js&"
export * from "./AdminAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddCompany.vue?vue&type=style&index=0&id=147921dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147921dc",
  null
  
)

export default component.exports